import Typography from '@mui/material/Typography';
import CardSection from '@shared/components/CardSection';
import type { SystemVersion } from '../types';

interface Props {
  versions: SystemVersion[];
}

export default function VersionInfo({ versions }: Props) {
  return (
    <CardSection>
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        Versions
      </Typography>
      <dl className="grid grid-cols-2 gap-x-4 gap-y-1 text-sm">
        {versions.map((v) => (
          <div key={v.component} className="contents">
            <dt className="text-[var(--color-text-secondary)]">{v.component}</dt>
            <dd className="font-mono">{v.version}</dd>
          </div>
        ))}
      </dl>
    </CardSection>
  );
}
